<template>
  <div class="news_detail_container" ref="newsPage">
    <!-- 详情 -->
    <detail :params="detailParams" :detail="detailInfo" :reporterMedia="reporterMedia"
      :reporterMediaList="reporterMediaList" v-if="!!detailInfo"></detail>
    <!-- 学习 -->
    <study :studyObj="studyObj" :params="detailParams" @closeStudy="closeStudy" v-if="studyObj.isStudy"></study>
    <!-- 相关新闻、精彩推荐 -->
    <related-news :contentList="relatedList" v-if="!!relatedList && relatedList.length > 0"></related-news>
    <!-- 活动 -->
    <activity :activityInfo="activity" v-if="!!detailInfo && !!activity"></activity>
    <!-- 投票 -->
    <vote :voteInfo="vote" v-if="!!detailInfo && !!vote"></vote>
    <!-- 广告 -->
    <advert :ads="detailInfo.ads" v-if="!!detailInfo && !!detailInfo.ads && detailInfo.ads.length > 0"></advert>
    <!-- 评论 -->
    <div ref="comment">
      <comment :params="commentParams" @replyForm="showCommentReplayForm" v-if="!!detailInfo"></comment>
    </div>
    <!-- 底部操作 -->
    <operate :params="detailParams" :contentId="detailInfo.contentId" :contentTitle="detailInfo.title"
      :isCollect="isCollect" :allow="detailInfo.allowComment" v-if="!!detailInfo && !headerHidden"
      @isToComment="isToComment" @showCommentForm="showCommentForm"></operate>
    <!-- 发布评论 -->
    <submit-comment v-if="!!detailInfo" :show="isShowCommentForm" :id="detailInfo.id" :type="detailInfo.contentType"
      :parentId="commentParentId" :title="detailInfo.title" @showCommentForm="showCommentForm"></submit-comment>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, clickPlayCount, addScore } from "@/utils";
import newsApi from "@/api/apis/news.js";
import commApi from "@/api/apis/common.js";
import detail from "./components/Detail"; //详情
import study from "./components/Study"; // 学习
import vote from "./components/Vote"; // 投票
import comment from "./components/Comment"; // 评论
import RelatedNews from "./components/RelatedNews"; // 相关新闻
import advert from "./components/Advert"; // 相关新闻
import activity from "./components/Activity"; // 相关新闻
import operate from "./components/Operate"; //底部
import submitComment from "./components/SubmitComment"; //发表评论

export default {
  name: "NewsDetail",
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
    /* 投票相关数据 */
    vote() {
      let vote = this.detailInfo.vote;
      if (!!vote && JSON.stringify(vote) != "{}") {
        return vote;
      } else {
        return null;
      }
    },
    /* 活动相关数据 */
    activity() {
      let activity = this.detailInfo.activity;
      if (!!activity && JSON.stringify(activity) != "{}") {
        return activity;
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      /* 是否显示评论表单 */
      isShowCommentForm: false,
      commentParentId: "0",
      isCollect: 0,
      /* 获取详情所需的参数 */
      detailParams: {
        contentType: null,
        contentId: null,
        cId: null,
        fromFlag: null,
      },
      /* 学习 */
      studyObj: {
        isStudy: 0, // 是否学习 1-是 0-否
        studyTime: 0, // 学习时间
      },
      /* 获取评论列表的参数 */
      commentParams: {
        contentId: null,
        type: null,
      },
      /* 详情信息 */
      detailInfo: null,
      /* 相关新闻 */
      relatedList: [],
      reporterMedia: null,
      reporterMediaList: [],
      shareUrl: "",
    };
  },
  components: {
    detail,
    study,
    vote,
    comment,
    RelatedNews,
    advert,
    activity,
    operate,
    submitComment,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/news_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        let subTitle = _this.detailInfo.introduction || _this.detailInfo.subtitle || _this.detailInfo.title;
        let imgUrl = _this.detailInfo.sharePictureUrl || _this.detailInfo.imgUrl

        _this.$WeiXin.shareWeiXin(res, _this.detailInfo.title, subTitle, _this.shareUrl, imgUrl);
      }).catch((err) => {

      })
    },
    /* 获取详情 */
    getNewsDetail() {
      var _this = this;
      if (!!this.userInfo) {
        _this.detailParams.memberId = this.userInfo.id;
      }

      newsApi
        .getNewsDetailById(_this.detailParams)
        .then((res) => {
          if (res.suc == 1) {
            if (res.data.title) res.data.title = res.data.title.replaceAll('\n', ' ')
            if (res.data.subtitle) res.data.subtitle = res.data.subtitle.replaceAll('\n', ' ')

            document.title = res.data.title;
            _this.detailInfo = res.data;
            if (_this.detailInfo.title && _this.detailInfo.title.includes('<br>')) {
              _this.detailInfo.title = _this.detailInfo.title.replace("<br>", " ")
            }

            _this.wechatShare(); // 微信二次分享
            _this.statistics(); // 统计
            _this.addScore(); // 增加积分
            let studyJsonData = res.data.studyJson;
            _this.studyObj = {
              isStudy: studyJsonData ? studyJsonData.isStudy : 0,
              studyTime: studyJsonData ? studyJsonData.duration : 0,
            };
            _this.commentParams.contentId = _this.detailInfo.id;
            _this.commentParams.type = _this.detailInfo.contentType;
            _this.getNewsOthers();
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          console.log('err', err)
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取除详情外的其他信息 */
    getNewsOthers() {
      var _this = this;
      if (!!_this.detailInfo.reporterFreIds) {
        _this.detailParams.reporterFreIds = _this.detailInfo.reporterFreIds;
      }
      newsApi
        .getNewsOthersById(_this.detailParams)
        .then((res) => {
          if (res.suc == 1) {
            _this.relatedList = res.data.relatedList;
            _this.relatedList.forEach(d => {
              if (d.title && d.title.includes('<br>')) {
                d.title = d.title.replace("<br>", " ")
              }

            })
            _this.isCollect = res.data.isCollect;
            _this.reporterMedia = res.data.reporterFreJSON;
            if (Object.prototype.hasOwnProperty.call(res.data, "reporterFreJSONArray")) {
              _this.reporterMediaList = res.data.reporterFreJSONArray;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.detailInfo.contentCreationTime, // 创建时间
        contentId: this.detailInfo.id, // 稿件Id
        contentTitle: this.detailInfo.title,
        contentType: 5,
        memberId: this.detailInfo.editorId, // 当前稿件的编辑者的id
        nickName: this.detailInfo.editor, // 当前稿件的编辑者的用户名称
      };
      if (this.detailParams.fromFlag == 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.detailInfo.channelId, // 栏目id
          channelName: this.detailInfo.channelName, // 栏目名称
        });
      } else if (this.detailParams.fromFlag == 1) {
        tj_params = Object.assign(tj_params, {
          channelId: this.detailInfo.specialId, // 专题id
          channelName: this.detailInfo.specialName, // 专题名称
        });
      } else if (this.detailParams.fromFlag == 2) {
        tj_params = Object.assign(tj_params, {
          channelId: this.detailInfo.channelJson.id, // 自媒体id
          channelName: this.detailInfo.channelJson.name, // 自媒体名称
        });
      }
      clickPlayCount(tj_params);
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "lnr", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "浏览内容", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.detailParams.contentType, // 非必传，稿件的type
        contentId: this.detailParams.contentId, // 非必传，稿件的id
        contentName: this.detailInfo.title, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
        addScore(jf_params);
      }
    },
    /* 关闭学习 */
    closeStudy() {
      this.studyObj.isStudy = 0;
    },
    /* 显示或隐藏评论表单 */
    showCommentForm(data) {
      this.isShowCommentForm = data;
      this.commentParentId = "0";
    },
    /* 评论回复,显示评论表单 */
    showCommentReplayForm(data) {
      this.isShowCommentForm = true;
      this.commentParentId = data;
    },
    /* 滚动到评论区域或顶部 */
    isToComment(flag) {
      if (flag) {
        let top = this.$refs.comment.offsetTop;
        this.$nextTick(() => {
          this.$refs.newsPage.scrollTo({
            top: top,
            left: 0,
            behavior: "smooth",
          });
        });
      } else {
        this.$nextTick(() => {
          this.$refs.newsPage.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        });
      }
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.detailParams.contentType = Number(query.contentType) || 5;
      this.detailParams.contentId = Number(query.contentId);
      this.detailParams.fromFlag = Number(query.fromFlag) || 0;
      this.detailParams.cId = Number(query.cId) || 0;
      if (!!this.userInfo) {
        this.detailParams.memberId = this.userInfo.id;
      }
      this.getNewsDetail();
      loadStat(); // 友盟统计
    }
  },
};
</script>
<style scoped lang="scss">
.news_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px 15px 60px;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>